import { UserInfo } from "models/user.model";

export const EMAIL_REG_EX = /^[a-zA-Z0-9_+-.±]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
export const PASSWORD_REG_EX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/;

export interface RequestState {
  errMsg: string;
  isValid: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isEdited?: boolean;
  isHidden?: boolean;
}

// 기타매입/기타매출/급여관리/기타세금 탭 및 AI 회계처리 버튼 제한 노출 대상 기관
// (UserInfo.taxOfficeOrgId 또는 payrollOfficeOrgId 기준)
export const EXTRA_MENU_ALLOWED_ORG_IDS = [
  "686b8ae18d3a9f106c183b9e", // 안세회계법인_유성식 세무대리
  "68f5da2deb390daeffe6f500", // 안세회계법인_유성식 급여대리
  "69489a5d449c12fbe244ed56", // (주)아이비즈온 세무대리
  "633e9163ca702e6d5d86f9b3" // 에이아이택스 세무대리 (개발 테스트용)
];

// 사용자의 소속 기관 ID. 세무대리 기관(taxOfficeOrgId)이 없으면 급여대리 기관(payrollOfficeOrgId)을 쓴다.
export const getUserOrgId = (userInfo?: UserInfo | null): string | null =>
  userInfo?.taxOfficeOrgId || userInfo?.payrollOfficeOrgId || null;

// taxOfficeOrgId, payrollOfficeOrgId 중 하나라도 허용 기관이면 제한 메뉴를 노출한다.
export const canSeeExtraMenusFor = (userInfo?: UserInfo | null): boolean =>
  [userInfo?.taxOfficeOrgId, userInfo?.payrollOfficeOrgId].some(
    (orgId) => !!orgId && EXTRA_MENU_ALLOWED_ORG_IDS.includes(orgId)
  );
